module.exports = __webpack_public_path__ + "static/media/MountainLion.svg";